var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.getEstablecimiento)?_c('b-container',[_c('tabla-cargo-personal',{attrs:{"seleccionable":true}}),_vm._v(" "),_c('registrar-solicitud-form',{attrs:{"personal":this.Personal,"cargopersonal":this.ListaCargoPersonal},on:{"form-solicitud-close":function($event){return _vm.cerrarModal($event)}}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11557c9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/solicitudes/RegistrarSolicitudPersonal.vue
// module id = +cft
// module chunks = 1